export const ReasonsForPractitionerLeaving = {
    RED_PQA: '007b8ef4-92e5-4d29-8bb4-edb5332346ee',
    OTHER: '528d108a-b70a-4cbb-943e-f799cecceba6',
};
//# sourceMappingURL=reason-for-practitioner-leaving.dto.js.map